export default __webpack_public_path__ + "static/taper-181970b552ed1f064ee827f46e2b83ba.png";